export default "__VITE_ASSET__b0dc34e1__"